// prettier-ignore
// this line automatically changed in CI
export const licenseKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImNjMDgzMGIzLThmNmQtNGZkOS04M2M5LTY5Y2RhYTAxYWFkNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.thq86Wl7kNKoEWgaixZrpmRp+zdM1jJkpjyFVEhR7fOWt5ZpbdeBOyGuK3OW32N0qOODmie0TtD/SS5ggkIRLaYdQJ4daDGBocV5oRjkbI0f1BdSqAim2HLw2zlhY8wfdn04Pg==';
